<template>
  <i  class="fa" :class="`fa-${name}`" aria-hidden="true">
  </i>
</template>
<script>
export default {
  name: 'icon',
  props: {
    name: {
      type: String,
      required: false
    }
  }
}
</script>
